"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconTextArea = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M66.77 14.47H18.59v3.39h45.74v40.46H5.67V17.86h4.24v-3.39H3.23a1 1 0 0 0-1 1v45.29a1 1 0 0 0 1 1h63.54a1 1 0 0 0 1-1V15.42a1 1 0 0 0-1-.95z"
  }), _react["default"].createElement("path", {
    d: "M12.89 29.58a.09.09 0 0 1-.09.09h-2.45a1 1 0 0 0-1 1v.63a1 1 0 0 0 1 1h2.45a2.78 2.78 0 0 0 1.45-.4 2.78 2.78 0 0 0 1.45.4h2.46a1 1 0 0 0 1-1v-.63a1 1 0 0 0-1-1H15.7a.09.09 0 0 1-.09-.09V11.09a.09.09 0 0 1 .09-.09h2.46a1 1 0 0 0 1-1v-.67a1 1 0 0 0-1-1H15.7a2.78 2.78 0 0 0-1.45.4 2.78 2.78 0 0 0-1.45-.4h-2.45a1 1 0 0 0-1 1V10a1 1 0 0 0 1 1h2.45a.09.09 0 0 1 .09.09z"
  })),
  height: undefined,
  width: undefined
});
IconTextArea.displayName = 'IconTextArea';
var _default = IconTextArea;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/text-area.js
// module id = 598
// module chunks = 0